import { render, staticRenderFns } from "./ElementObjectExtra.vue?vue&type=template&id=27cee878"
import script from "./ElementObjectExtra.vue?vue&type=script&lang=ts"
export * from "./ElementObjectExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports